<template lang="pug" src="./tab-lucas-difference.pug"></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      active: 0
    }
  },
  methods: {
    showContent (i) {
      this.active = i
    }
  }
}
</script>



// WEBPACK FOOTER //
// tab-lucas-difference.vue?07a2506b